 <template>
 <!--========== HEADER ==========-->
    <header class="head-site header-page" 
        :style="{ backgroundImage: 'url(' + require('../../assets/img/guiadivulgamaisbrasil-bg.jpg') + ')' }">
        <div class="container">


            <div class="row">
                <div class="col-sm-2 col-xs-8">
                    <div class="logo-header">
                        <router-link to="/">
                            <img src="../../assets/img/guiadivulgamaisbrasil-logo.png" class="img-responsive" />
                        </router-link>
                    </div>
                </div>
            </div>

        </div>


        <div class="subnav">

            <div class="container">
                <div class="row">
                    <!--<div class="col-md-4 col-md-offset-2 col-sm-8 col-xs-12">-->
                    <div class="col-md-8 col-md-offset-2 col-sm-8 col-xs-12">
                        <div class="search-area">
                                <div class="input-group">
                                    <input type="text" class="search-input form-control" placeholder="O que você procura?" v-on:keyup.enter="doSearch" v-model="searchTerms" name="s" tabindex="1" autocomplete="off">
                                    <button class="btn btn-default search-button" type="button" tabindex="2" v-on:click="doSearch()">
                                        <span class="fa fa-search"></span>
                                    </button>
                                </div>
                        </div>

                    </div>

                    <div class="col-md-5 col-sm-4 col-xs-12 hidden">
                        <div class="phone-header">
                            <div class="row">
                                <div class="col-xs-2">
                                    <span class="fa fa-mobile ic-phone"></span>
                                </div>
                                <div class="col-xs-10">
                                    <p> <span>Central de atendimento:</span> (11) 98888-8888 </p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>


            <div class="container">
                <div class="row">
                    <div class="col-sm-12 text-center">
                        <p class="breadcrumb-pages" v-if="breadcrumbs">
                            <router-link to="/">Página inicial</router-link> » <span>{{category}}</span>
                        </p>
                        <p class="breadcrumb-pages" v-if="searchterms">
                            <router-link to="/">Buscando por</router-link> » <span>{{searchterms}}</span>
                        </p>
                    </div>
                </div>
            </div>

    </header>
    <!--========== END HEADER ==========-->
</template>

<script>
export default {
  name: 'HeaderView',
  props: {
   titulo: {
    type: String
   },
   breadcrumbs: {
       type: Boolean
   },
   categories: {
       type: Array,
       default: []
   },
   category: {
       type: String
   },
   searchterms: {
       type: String
   }
  },
  data: function () {
    return {
      year: new Date().getFullYear(),
      searchTerms: '',
      nameRoute: ''
    }
  },
  methods: {
    doSearch: function() {
      if (this.nameRoute == 'busca') {
          // executa o método na página de busca
          this.$router.push({ path: '/busca', query: { search: this.searchTerms } })
          this.$parent.doSearch(this.searchTerms)
      } else {
          // vai para a página de busca e executa o método de lá
          this.$router.push({ path: '/busca', query: { search: this.searchTerms } })
      }
       console.log('buscando: ',this.searchTerms)
    }
  },
  mounted() {
      this.nameRoute = this.$router.currentRoute.name;
  }
}
</script>


// WEBPACK FOOTER //
// src/components/layout/Header.vue